import { memo } from 'react';
import { Button, Link } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

import './styles.scss';

const AutomationBuilderFooter = memo(({ onSave, onClose }) => {
    return (
        <div className="fm-automation-builder__footer">
            <div className="fm-automation-builder__footer-left">
                <Link
                    href={getLiteral('label_send_us_feedback_form')}
                    target="_blank"
                    variation="primary"
                >
                    {getLiteral('action_send_us_feedback')}
                </Link>
            </div>
            <div className="fm-automation-builder__footer-right">
                <Button onClick={onClose} type="terciary">
                    {getLiteral('action_cancel')}
                </Button>
                <Button type="secondary" onClick={onSave}>
                    {getLiteral('action_save_automation')}
                </Button>
            </div>
        </div>
    );
});

export default AutomationBuilderFooter;
